var m = require('mithril');
var Model = require('../../libs/Model');

var group = Object.create(Model)

group.name = 'Group';
group['@class'] =  'Group'
group.url = 'group'

group.fields = {
  name: {
    default: null,
    validators : {
      presence : true,
      length: {
        minimum: 3, 
        maximum: 32, 
        default: ''
      }, 
    }
  },
  members: []
};

group.initForm = function (record) {
  group.vm = {};
  if (record.members) {
    record.members = record.members.map(function (r) {
      if (r && r['@rid']) return r;
    })
  }
  Model.initForm.call(group, record);
};

group.save = function () {
  if(!group.form.members()) {
    group.form.members([]);
  }
  group.form.members(
    group.form.members().map(function (r) {
      return r['@rid'];
    })
  );
  return Model.save.call(group);

}

group.view = function () {
  return m("form", {role: "form"}, [
    group.errorView(),
    m("div", {class:"form-group"}, [
      m('label', 'Name:'),
      m("input.form-control", {
        type:"text", 
        autocomplete: 'off',
        oninput: function(ev){group.form.name(ev.target.value)},
        value: group.form.name(),
      }),
    ])
  ])
};

module.exports = group;
